import React from "react";
import ScanHand from "../../ScanHand";

const Screen11 = () => {
    return <ScanHand />;
};

export default Screen11;
